import React, { useState } from 'react'
import {
  Button, Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap'
import PropTypes from 'prop-types'

import SavingSpinner from './SavingSpinner'

const ActionModal = ({
  isOpen,
  headerText,
  Body,
  toggle,
  confirmAction,
}) => {
  const [running, setRunning] = useState(false)
  const onClick = async () => {
    setRunning(true)
    await confirmAction()
    setRunning(false)
    toggle()
  }

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>{headerText}</ModalHeader>
        <ModalBody>
          <Body />
        </ModalBody>
        <ModalFooter>
          <div className="p-2">
            <Button color="primary" onClick={onClick}>Confirm</Button>
          </div>
          <div className="p-2">
            <Button color="secondary" onClick={toggle}>Cancel</Button>
          </div>
        </ModalFooter>
      </Modal>
      { running && <SavingSpinner /> }
    </>
  )
}

ActionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  headerText: PropTypes.string.isRequired,
  Body: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  confirmAction: PropTypes.func.isRequired,
}

export default ActionModal
